import "./TagLabel.css";

export const TagLabel = ({ text }) => (
  <div className="tagLabel">
    <div className="text">{text}</div>
  </div>
);

export default TagLabel;